// src/pages/ScheduleRulesPage.jsx
import { useEffect, useState } from "react";
import MastersCrudPage from "../components/MastersCrudPage";
import {
  listScheduleRules,
  createScheduleRule,
  updateScheduleRule,
  deleteScheduleRule,
  listResources,
  listLocations,
} from "../api/mastersApi";

const WEEKDAYS = [
  { v: 0, label: "Domingo" },
  { v: 1, label: "Lunes" },
  { v: 2, label: "Martes" },
  { v: 3, label: "Miércoles" },
  { v: 4, label: "Jueves" },
  { v: 5, label: "Viernes" },
  { v: 6, label: "Sábado" },
];

export default function ScheduleRulesPage() {
  const [resources, setResources] = useState([]);
  const [locations, setLocations] = useState([]);

  useEffect(() => {
    (async () => {
      try {
        const data = await listResources();
        // Normalizar la respuesta: data puede ser un array, o un objeto con { data: [...] }, etc.
        if (Array.isArray(data)) {
          setResources(data);
        } else if (data && Array.isArray(data.data)) {
          setResources(data.data);
        } else if (data && Array.isArray(data.resources)) {
          // por si la API devuelve { resources: [...] }
          setResources(data.resources);
        } else if (data && Array.isArray(data.locations)) {
          // por si la API devuelve { locations: [...] }
          setResources(data.locations);
        } else {
          setResources([]); // fallback seguro
        }        
      } catch (err) {
        console.error("Error listResources", err);
        setResources([]);
      }
  
      try {
        const data = await listLocations();

        if (Array.isArray(data)) {
          setLocations(data);
        } else if (data && Array.isArray(data.data)) {
          setLocations(data.data);
        } else if (data && Array.isArray(data.resources)) {
          // por si la API devuelve { resources: [...] }
          setLocations(data.resources);
        } else if (data && Array.isArray(data.locations)) {
          // por si la API devuelve { locations: [...] }
          setLocations(data.locations);
        } else {
          setLocations([]); // fallback seguro
        }

      } catch (err) {
        console.error("Error listLocations", err);
        setLocations([]);
      }
    })();
  }, []);

  return (
    <MastersCrudPage
      title="Schedule Rules"
      fetchList={listScheduleRules}
      createItem={createScheduleRule}
      updateItem={updateScheduleRule}
      deleteItem={deleteScheduleRule}
      columns={[
        { key: "id", label: "ID" },
        { key: "resource_name", label: "Recurso" },
        { key: "location_name", label: "Sede" },
        { key: "weekday", label: "Día" },
        { key: "start_time", label: "Desde" },
        { key: "end_time", label: "Hasta" },
        { key: "is_active", label: "Activo" },
      ]}
      initialForm={() => ({ resource_id: null, location_id: null, weekday: 1, start_time: "09:00", end_time: "17:00", is_active: 1 })}
      renderForm={({ form, setForm }) => (
        <>
          <div className="grid grid-cols-2 gap-2">
            <div>
              <label className="block text-xs text-gray-400">Recurso</label>
              <select value={form.resource_id ?? ""} onChange={e => setForm({...form, resource_id: e.target.value ? Number(e.target.value) : null})} className="w-full p-2 rounded bg-[#020817] border border-gray-700">
                <option value="">-- sin recurso --</option>
                {resources.map(r => <option key={r.id} value={r.id}>{r.name}</option>)}
              </select>
            </div>

            <div>
              <label className="block text-xs text-gray-400">Sede</label>
              <select value={form.location_id ?? ""} onChange={e => setForm({...form, location_id: e.target.value ? Number(e.target.value) : null})} className="w-full p-2 rounded bg-[#020817] border border-gray-700">
                <option value="">-- sin sede --</option>
                {locations.map(l => <option key={l.id} value={l.id}>{l.name}</option>)}
              </select>
            </div>
          </div>

          <div className="grid grid-cols-3 gap-2">
            <div>
              <label className="block text-xs text-gray-400">Día</label>
              <select value={form.weekday} onChange={e => setForm({...form, weekday: Number(e.target.value)})} className="w-full p-2 rounded bg-[#020817] border border-gray-700">
                {WEEKDAYS.map(w => <option key={w.v} value={w.v}>{w.label}</option>)}
              </select>
            </div>

            <div>
              <label className="block text-xs text-gray-400">Desde (HH:MM)</label>
              <input type="time" value={form.start_time} onChange={e => setForm({...form, start_time: e.target.value})} className="w-full p-2 rounded bg-[#020817] border border-gray-700" />
            </div>

            <div>
              <label className="block text-xs text-gray-400">Hasta (HH:MM)</label>
              <input type="time" value={form.end_time} onChange={e => setForm({...form, end_time: e.target.value})} className="w-full p-2 rounded bg-[#020817] border border-gray-700" />
            </div>
          </div>

          <div>
            <label className="block text-xs text-gray-400">Activo</label>
            <select value={form.is_active} onChange={e => setForm({...form, is_active: Number(e.target.value)})} className="w-full p-2 rounded bg-[#020817] border border-gray-700">
              <option value={1}>Sí</option>
              <option value={0}>No</option>
            </select>
          </div>
        </>
      )}
    />
  );
}
